module.exports = __webpack_public_path__ + "img/1488171922.7003d0b5.jpg";